import { useLayoutEffect, useState, useRef } from 'react';

import Link from 'components/link/Link';
import Search from 'components/search/Search';
import Icon from 'components/icon/Icon';
import Form from 'components/form/Form';

import { IErrorPage } from 'source/NFR.types';

const ErrorPage: React.FC<IErrorPage> = ({ errorCode, link, title, message, search, text, form }) => {
  const errorPageRef = useRef<HTMLDivElement>(null);
  const [errorPageHeight, setErrorPageHeight] = useState<number | null>(null);

  // Use layout effect to avoid a flash before the measured height applies
  useLayoutEffect(() => {
    const recalc = () => {
      const el = errorPageRef.current;
      if (!el || typeof window === 'undefined' || typeof document === 'undefined') return;

      const currentBlock = el.offsetHeight;
      const documentHeight = document.body.scrollHeight;
      const nonErrorPageHeight = documentHeight - currentBlock;
      const height = window.innerHeight - nonErrorPageHeight;

      setErrorPageHeight(height);
    };

    recalc(); // initial measure
    window.addEventListener('resize', recalc, { passive: true });
    return () => window.removeEventListener('resize', recalc);
  }, []);

  return (
    <div className="error-page" ref={errorPageRef} style={errorPageHeight ? { height: errorPageHeight } : undefined}>
      <div className="error-page__content">
        <Icon className="error-page__icon" name="dubian-path" />
        <div className="error-page__content-inner">
          {errorCode && <h1 className="error-page--code">{errorCode}</h1>}
          {title && <div className="error-page--title">{title}</div>}
          {message && <div className="error-page--message">{message}</div>}
          {text && <p className="error-page--text">{text}</p>}
          {search && (
            <Form showSubmitButton={false} {...form}>
              <Search {...search} />
            </Form>
          )}
          {link && <Link theme="black" className="error-page--link" {...link} />}
        </div>
      </div>
    </div>
  );
};

ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
